<div class="filter-container" appUserManual [userManualKey]="'signature-role-matrix-filter'">
  <div class="matrix-toolbar">
    <div class="search-container">
      <mat-form-field appearance="outline" class="matrix-search">
        <mat-label>Search users</mat-label>
        <input matInput placeholder="Type to filter users" [ngModel]="userFilter" (ngModelChange)="onUserFilterChange($event)" />
      </mat-form-field>
    </div>
    <app-role-toggle-filter [value]="roleFilter" (valueChange)="onRoleFilterChange($event)"></app-role-toggle-filter>
  </div>
</div>

<div class="table-container">
  @let vm = vm$ | async;
  <app-project-role-matrix
    [vm]="vm"
    [hasRole]="hasSignatureRole.bind(this)"
    [getRoleIcon]="getRoleIcon.bind(this)"
    [toggleRole]="toggleSignatureRole.bind(this)"
  ></app-project-role-matrix>
</div>
